import { featureFlagClient } from './core/featureFlagClient';
import type { BooleanFlagDetails, FeatureFlagProvider } from './core/featureFlagClient.types';
import type { PortalFeatureFlagDefinition } from './featureFlagDefinition';

type BooleanPortalFeatureFlagDefinition = PortalFeatureFlagDefinition<
  FeatureFlagProvider,
  'boolean'
>;

export function getFeatureFlagBooleanDetails(
  definition: BooleanPortalFeatureFlagDefinition,
  defaultValue: boolean
): BooleanFlagDetails {
  return featureFlagClient.getBooleanDetails(definition.key, defaultValue, {
    provider: definition.provider,
  });
}

/**
 * True only when the provider is ready and Split returned an explicit off/false
 * treatment. Missing flags (FLAG_NOT_FOUND / control) are not treated as off.
 */
export function isBooleanFeatureFlagExplicitlyOff(
  details: BooleanFlagDetails,
  isReady: boolean
): boolean {
  return isReady && details.errorCode == null && details.value === false;
}
